export default [{
  path: 'speedAlarmStatistics',
  name: 'speedAlarmStatistics',
  component: function component() {
    return import('@/views/speedManage/speedAlarmStatisticsManage/index');
  }
}, {
  path: 'speedAlarmRecord',
  name: 'speedAlarmRecord',
  component: function component() {
    return import('@/views/speedManage/speedAlarmRecordManage/index');
  }
}];